// extracted by mini-css-extract-plugin
export default {"main":"Dashboard_main__JyFM6","inputFelid":"Dashboard_inputFelid__5bQSa","userDetailsLabel":"Dashboard_userDetailsLabel__a1DS8"};